<template>
  <form
    class="login"
    @keyup.enter="submit"
  >
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
    />
    <div class="title">
      <h1 class="text-center m-0">
        Willkommen!
      </h1>
    </div>
    <div class="subtitle">
      <p class="text-center m-0">
        Los geht's! Für alle, die schon registriert sind &ndash; bitte hier einloggen.
      </p>
    </div>
    <BaseInput
      name="email"
      label="E-Mail-Adresse"
      :value="form.email"
      outlined
      rounded
      :error="errors.get('email')"
      autocomplete="on"
      @update="updateItem(['email', $event])"
    />
    <BaseInput
      name="password"
      label="Passwort"
      :value="form.password"
      type="password"
      outlined
      rounded
      :error="errors.get('password')"
      autocomplete="on"
      @update="updateItem(['password', $event])"
    />
    <div class="flex justify-between items-center">
      <BaseCheckbox
        v-model="form.remember"
        label="Angemeldet bleiben"
      />
      <BaseButtonV2
        v-if="showReset"
        class="reset"
        type="link"
        color="text"
        :href="request"
        medium
      >
        Passwort vergessen?
      </BaseButtonV2>
    </div>
    <BaseFormControls
      :next-disabled="!isSubmitEnabled || submitted"
      previous-hidden
      full-width
      @next="submit"
    >
      <template #next>
        Anmelden
      </template>
    </BaseFormControls>
  </form>
</template>

<script>
import axios from 'axios';

import Loading from 'vue-loading-overlay';
import FormErrors from '../utils/FormErrors';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'BaseLoginForm',
  components: {
    Loading,
  },
  props: {
    defaults: Object,
    action: String,
    request: String,
  },
  data() {
    return {
      errors: new FormErrors(),
      isLoading: false,
      submitted: false,
      form: this.defaults,
    };
  },
  computed: {
    showReset() {
      return !!this.request;
    },
    isSubmitEnabled() {
      return !!this.form.email?.trim() && !!this.form.password?.trim();
    },
  },
  methods: {
    async submit() {
      this.errors.clear();

      try {
        this.isLoading = true;
        this.submitted = true;
        const response = await axios.post(this.action, {
          ...this.form,
        });
        window.location.href = response.data.redirectTo;
      } catch (err) {
        this.errors.record(err.response.data.errors);
      } finally {
        this.isLoading = false;
        this.submitted = false;
      }
    },
    reset() {
      window.location.href = this.request;
    },
    updateItem(data) {
      const [key, value] = data;
      this.errors.clear(key);
      this.form[key] = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  --gap: 1.25rem;

  display: flex;
  flex-direction: column;
  gap: var(--gap);

  .title {
    h1 {
      font-size: 2.875rem;
      font-weight: 300;
    }
  }

  .subtitle {
    margin-bottom: calc(var(--gap) * 2);

    p {
      font-size: 1rem;
      font-weight: 500;
    }
  }

  .reset {
    padding: 0;
    font-weight: 400;
  }
}
</style>
